import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
function Progress({
  color = "default",
  noCornerRadius,
  noBackground,
  width,
  ...props
}) {
  return /* @__PURE__ */ jsx(Track, {
    role: "progressbar",
    "aria-valuenow": width,
    $noCornerRadius: noCornerRadius,
    $noBackground: noBackground,
    ...props,
    children: /* @__PURE__ */ jsx(Fill, {
      $color: color,
      $noCornerRadius: noCornerRadius,
      style: {
        width: width + "%"
      }
    })
  });
}
const Track = styled.div.withConfig({
  displayName: "Track",
  componentId: "sc-183yznk-0"
})(["height:4px;border-radius:", ";background:", ";"], (props) => props.$noCornerRadius ? "0" : token.radiusPill, (props) => props.$noBackground ? "none" : token.gray100a);
const Fill = styled.div.withConfig({
  displayName: "Fill",
  componentId: "sc-183yznk-1"
})(["max-width:100%;height:100%;border-radius:", ";background:", ";transition:width 0.2s ease-out;"], (props) => props.$noCornerRadius ? "0" : token.radiusPill, (props) => props.$color === "brand" ? token.brandPrimary500 : token.gray600);
export {
  Fill,
  Progress,
  Track
};
//# sourceMappingURL=Progress.js.map
